<template>
  <div class="tab-container">
    <div class="tab-section">
      <VForm :callback="() => {}">
        <template #form-body>
          <h4>Modifier vos informations personnelles</h4>
          <div class="input-inline">
            <VField
              name="profil-firstname"
              rules="required|textOnly"
              v-model="candidate.first_name"
              :label="$t('form.register.firstName')"
              :disabled="true"
            />
            <VField
              name="profil-lastname"
              rules="required|textOnly"
              v-model="candidate.last_name"
              :label="$t('form.register.lastName')"
              :disabled="true"
            />
          </div>
          <div class="input-inline">
            <div class="input-wrapper">
              <label for="phone">{{ $t("form.register.phone") }}</label>
              <vue-tel-input
                id="phone"
                v-model="candidate.phone_number"
                :required="true"
                :disabled="true"
              >
                <template v-slot:arrow-icon>
                  <i class="bi bi-chevron-down" />
                </template>
              </vue-tel-input>
            </div>
            <VField
              type="email"
              name="profil-mail"
              rules="required|email"
              v-model="candidate.email"
              :label="$t('form.email')"
              :disabled="true"
            />
          </div>
        </template>
      </VForm>
    </div>
    <div class="tab-section">
      <h3>Modifier votre mot de passe</h3>
      <VForm
        :button="{
          label: 'Réinitialiser votre mot de passe',
          class: 'primary',
          hotDisabled: true,
        }"
        :callback="changeMyPassword"
        :clean="true"
      >
        <template #form-body="{ errors }">
          <VField
            type="password"
            placeholder="••••••••••••"
            name="profil-current-password"
            v-model="state.currentPassword"
            rules="required"
            icon="bi-lock"
            :label="$t('form.currentPassword')"
            :class="{
              invalid: Object.keys(errors)[0] === 'profil-current-password',
            }"
          />
          <div class="input-inline">
            <VField
              type="password"
              placeholder="••••••••••••"
              name="profil-new-password"
              v-model="state.newPassword"
              icon="bi-lock"
              rules="required|password|is_not:@profil-current-password"
              :helper="$t('form.register.must8char')"
              :label="$t('form.newPassword')"
              :class="{
                invalid: Object.keys(errors)[0] === 'profil-new-password',
              }"
            />
            <VField
              type="password"
              placeholder="••••••••••••"
              name="profil-confirm-password"
              v-model="state.confirmPassword"
              icon="bi-lock"
              rules="required|match:@profil-new-password"
              :label="$t('form.confirmNewPassword')"
              :class="{
                invalid: Object.keys(errors)[0] === 'profil-confirm-password',
              }"
            />
          </div>
        </template>
      </VForm>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useCandidateStore } from "@/stores/candidate.js";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";

const { candidate, updatePassword } = useCandidateStore();

const toast = useToast();

const state = reactive({
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
  error: "",
});

async function changeMyPassword() {
  const resp = await updatePassword(state.currentPassword, state.newPassword);

  if (resp.code) {
    toast.error(
      resp.key === "ERROR_AUTH_INVALID_CREDENTIALS"
        ? "Mot de passe actuel incorrect"
        : getError(resp.key)
    );
  } else {
    toast.success("Mot de passe modifié");
  }
}
</script>
